import { render, staticRenderFns } from "./OrderField.vue?vue&type=template&id=5ba43f42&scoped=true"
import script from "./OrderField.vue?vue&type=script&lang=js"
export * from "./OrderField.vue?vue&type=script&lang=js"
import style0 from "./OrderField.vue?vue&type=style&index=0&id=5ba43f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba43f42",
  null
  
)

export default component.exports